import { render } from "./NewVisitPanel.vue?vue&type=template&id=674b8262&scoped=true"
import script from "./NewVisitPanel.vue?vue&type=script&lang=js"
export * from "./NewVisitPanel.vue?vue&type=script&lang=js"

import "./NewVisitPanel.vue?vue&type=style&index=0&id=674b8262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674b8262"]])

export default __exports__